module.exports = __webpack_public_path__ + "static/media/VideoDemoV1.98ce7493.mov";